// Store.
import { AppState } from 'store';
import { IReport } from './types';

export const isLoadingReportsSelector = ({ reportState }: AppState): boolean => reportState.isLoadingReports;
export const isLoadingReportSelector = ({ reportState }: AppState): boolean => reportState.isLoadingReport;
export const reportSelector = ({ reportState }: AppState): any => reportState.report;
export const reportsSelector = ({ reportState }: AppState): IReport[] => reportState.reports;
